import {format} from "date-fns";
import BinaryData from "./BinaryData";

export class EmlakBeyanBildirim {
  public tip: string = "";
  public beyanTarihi: string = format(new Date(), "yyyy-MM-dd");
  public beyanYili: number = new Date().getFullYear();
  public beyanKabulTarihi: Date = new Date();
  public beyanVerilisTur: string = "";
  public beyanVerilisSekli: string = "";
  public mahalleId: string = "";
  public sokakId: string = "";
  public kapiNo: string = "";
  public bagNo: string = "";
  public katNo: string = "";
  public blokNo: string = "";
  public paftaNo: string = "";
  public adaNo:  string = "";
  public parselNo:  string = "";
  public ciltNo: string = "";
  public sahifeNo: string = "";
  public arsaAlani:  string = "";
  public arsaAlaniPayi:  string = "";
  public arsaAlaniPaydasi:  string = "";
  public arsaAlaniHisse:  number = 0;
  public araziDegerId: string = "";
  public araziMevkiId: string = "";
  public insaatTurId: string = "";
  public insaatSinifId: string = "";
  public kullanimSekliId: string = "";
  public insaatinBitimTarihi: string = "";
  public iktisapTarihi: string = "";
  public distanDisaM2:  string = "";
  public hisseOraniPayi:  string = "1";
  public hisseOraniPaydasi:  string = "1";
  public kaloriferli: boolean = false;
  public asansorlu: boolean = false;
  public aciklama: string = "";
  public kimlikBelge: BinaryData = new BinaryData();
  public tapuBelge: BinaryData = new BinaryData();
  public yapiRuhsatBelge: BinaryData = new BinaryData();
  public yapiIzinBelge: BinaryData = new BinaryData();
  constructor(tip: string) {
    this.tip = tip;
    this.beyanTarihi = format(new Date(), "dd/MM/yyyy");
    this.beyanYili = new Date().getFullYear();
    this.beyanKabulTarihi = new Date();
    this.beyanVerilisTur = "";
    this.beyanVerilisSekli = "";
    this.mahalleId = "";
    this.sokakId = "";
    this.kapiNo = "";
    this.bagNo = "";
    this.katNo = "";
    this.blokNo = "";
    this.paftaNo = "";
    this.ciltNo = "";
    this.sahifeNo = "";
    this.arsaAlani = "";
    this.arsaAlaniPayi = "";
    this.arsaAlaniPaydasi = "";
    this.arsaAlaniHisse = 0;
    this.insaatTurId = "";
    this.araziDegerId = "";
    this.araziMevkiId = "";
    this.insaatSinifId = "";
    this.kullanimSekliId = "";
    this.insaatinBitimTarihi = "";
    this.iktisapTarihi = "";
    this.kaloriferli = false;
    this.asansorlu = false;
    this.distanDisaM2 = "";
    this.hisseOraniPayi = "1";
    this.hisseOraniPaydasi = "1";
    this.aciklama = "";
    this.kimlikBelge = new BinaryData();
    this.tapuBelge = new BinaryData();
    this.yapiRuhsatBelge = new BinaryData();
    this.yapiIzinBelge = new BinaryData();
  }
}
